import { CSSProperties } from 'react';
import styled from 'styled-components';
import { colors } from 'styles/colors';

type Variant = 'new-radio';

export const LabelWrap = styled.label<{
  uncheckedColor?: string;
  cursor: CSSProperties['cursor'];
  variant?: Variant;
  disabled?: boolean;
}>(
  ({
    variant, uncheckedColor, cursor, disabled,
  }) => `
  display: inline-flex;
  align-items: center;
  color: ${uncheckedColor};
  cursor: ${cursor};

  ${handleWrapperStylesByVariant(variant, disabled)}
`,
);

const handleWrapperStylesByVariant = (
  variant?: Variant,
  disabled?: boolean,
): string => {
  if (variant === 'new-radio') {
    return `
      gap: 8px;
      ${disabled ? `
        cursor: disabled;
        pointer-events: none;
      ` : ''}
    `;
  }

  return '';
};

export const Radio = styled.div<{
  checked?: boolean;
  variant?: Variant;
  disabled?: boolean;
}>`
  line-height: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;

  ${({ color, checked, variant }) => handleRadioStylesByVariant(color, checked, variant)}
`;

const handleRadioStylesByVariant = (
  color?: string,
  checked?: boolean,
  variant?: Variant,
): string => {
  if (variant === 'new-radio') {
    const checkColor = checked
      ? colors.stroke['primary-base']
      : colors.stroke['sub-300'];

    return `
      background-color: transparent;
      height: 24px;
      width: 24px;
      border: 1px solid ${checkColor};
    `;
  }

  return `
    width: 1.37em;
    border: 0.143em solid ${color};
    background-color: ${colors.White};
  `;
};

export const Cursor = styled.div<{
  checked?: boolean;
  variant?: Variant;
  disabled?: boolean;
}>`
  line-height: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 0;
  border-radius: 50%;

  ${({
    color, checked, variant, disabled,
  }) => handleCursorStylesByVariant(color, checked, variant, disabled)}
`;

const handleCursorStylesByVariant = (
  color?: string,
  checked?: boolean,
  variant?: Variant,
  disabled?: boolean,
): string => {
  if (variant === 'new-radio') {
    const disabledBackground = disabled
      ? colors.icon['disabled-300']
      : undefined;
    const checkBackground = checked
      ? colors.stroke['primary-base']
      : colors.stroke['sub-300'];

    if (!checked) {
      return `
        display: none;
      `;
    }

    return `
      height: 14px;
      width: 14px;
      background-color: ${disabledBackground ?? checkBackground};
    `;
  }

  return `
    margin: 0.143em;
    width: 0.8em;
    height: 0.8em;
    background-color:${color};
  `;
};

export const Label = styled.span<{ variant?: Variant; disabled?: boolean }>`
  ${({ variant, disabled }) => handleLabelStylesByVariant(variant, disabled)}
`;

const handleLabelStylesByVariant = (variant?: Variant, disabled?: boolean): string => {
  if (variant === 'new-radio') {
    return `
      font-size: 12px;
      font-weight: 400;
      color: ${disabled ? colors.text['disabled-300'] : colors.text['main-900']};
      line-height: 180%;
    `;
  }

  return `
    padding-left: 0.6em;
  `;
};
